export default __webpack_public_path__ + "static/media/prescription.ab08bbbe.svg";